import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, Subject } from "rxjs";

import { Injectable } from "@angular/core";
import { endpoints } from "../_config/url-endpoint";

@Injectable({
  providedIn: "root",
})
export class MarketingConfigurationServices {
  constructor(private http: HttpClient) {}

  createMarketingConfiguration(body): Observable<any> {
    return this.http.post(endpoints.marketingConfiguration.createMarketingConfiguration, body);
  }

  getMarketingConfigurations(payload = null): Observable<any> {
    let url = `${endpoints.marketingConfiguration.getMarketingConfigurations}?${payload}`;
    if (!payload) {
      url = `${endpoints.marketingConfiguration.getMarketingConfigurations}`;
    }
    return this.http.get(url);
  }

  updateMarketingConfiguration(body, marketingConfigurationId): Observable<any> {
    // Check if body is FormData (has file) or regular object
    let url = `${endpoints.marketingConfiguration.updateMarketingConfigurationWithFile}/${marketingConfigurationId}`;
    return this.http.put(url, body);
  }

  downloadMarketingConfigurations(payload = null): Observable<Blob> {
    let url = `${endpoints.marketingConfiguration.downloadMarketingConfigurations}?${payload}`;
    if (!payload) {
      url = `${endpoints.marketingConfiguration.downloadMarketingConfigurations}`;
    }
    return this.http.get(url, { responseType: 'blob' });
  }

  deleteMarketingConfiguration(marketingConfigurationId: string): Observable<any> {
    return this.http.delete(`${endpoints.marketingConfiguration.deleteMarketingConfiguration}/${marketingConfigurationId}`);
  }
}

